import styled from 'styled-components';
import { Button } from '@material-ui/core';

export const RedButton = styled(Button)`
  color: #e05959 !important;
`;
